import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as CommunityContextConsumer } from '../../../contexts/CommunityContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import GroupLayout from '../../CallToAction/HoverCallToAction/GroupLayout/GroupLayout';
import HoverCallToActionWrapperComponent from '../../CallToAction/HoverCallToAction/HoverCallToActionWrapperComponent/HoverCallToActionWrapperComponent';
import TopicLayout from '../../CallToAction/HoverCallToAction/TopicLayout/TopicLayout';
import UserLayout from '../../CallToAction/HoverCallToAction/UserLayout/UserLayout';
import { AuthorProps } from '../../Includes/AuthorProps';
import { GroupCondensedPropShape } from '../../Includes/GroupPropsShape';
import { SingleContentTopicProps } from '../../Includes/TopicPropsShape';
import KarmaScoreDisplay from '../../Users/KarmaScoreDisplay/KarmaScoreDisplay';
import UserImage from '../User/UserDisplay/UserImage/UserImage';
import { constructCn, isEmpty } from '../../../utilities/helperFunctions';

import './CreatorComponent.scss';

export default class CreatorComponent extends React.Component {
    checkHighlighted = (author, userIsFGB) => {
        if (author.isHighlightedUser && userIsFGB) {
            return 'highlighted';
        }
        return '';
    };

    getGroupsComponent = (context) => {
        const { group, contentHash } = this.props;
        const { name, groupUrl } = group;

        return (
            <HoverCallToActionWrapperComponent
                hoverComponent={<GroupLayout group={group} />}
                contentHash={`${contentHash}-group`}
                contextHoverFunction={context.setHoverComponent}
                contextHoveredComponent={context.hoveredComponent}
                contextCloseHover={context.closeHoverComponent}
            >
                <a href={groupUrl}>{name}</a>
            </HoverCallToActionWrapperComponent>
        );
    };

    getTopicsComponent = (context) => {
        // return null; // Uncomment to make hovers persist
        return context.topics && context.topics[this.props.topic.id] ? (
            <HoverCallToActionWrapperComponent
                contentHash={`${this.props.contentHash}-topic`}
                contextHoverFunction={context.setHoverComponent}
                contextHoveredComponent={context.hoveredComponent}
                contextCloseHover={context.closeHoverComponent}
                hoverComponent={
                    <TopicLayout topic={context.topics[this.props.topic.id]} />
                }
            >
                <a
                    href={`/community/${
                        context.topics[this.props.topic.id].url
                    }`}
                    className="topic-link"
                >
                    {context.topics[this.props.topic.id].title}
                </a>
            </HoverCallToActionWrapperComponent>
        ) : (
            <a
                href={`/community/${this.props.topic.url}`}
                className="topic-link"
            >
                {this.props.topic.label}
            </a>
        );
    };

    render() {
        const { className } = this.props;
        const { userId } = this.props.author;
        const wrapperClassname = constructCn(
            'component-Content-CreatorComponent',
            className
        );

        return (
            <div className={wrapperClassname}>
                <PageConsumer>
                    {(pageContext) => (
                        <CommunityContextConsumer>
                            {(context) => {
                                let { author } = this.props;
                                const user = pageContext.pageProps.session;
                                const isHighlighted = false;
                                let isVip = false;
                                if (context.authorRefs[userId]) {
                                    author = context.authorRefs[userId];
                                    isVip =
                                        author &&
                                        author.userCommunityData &&
                                        author.userCommunityData.isVip;
                                }
                                const highlightedClass = this.checkHighlighted(
                                    author,
                                    pageContext.userIsFGB
                                );

                                const userImage = (
                                    <HoverCallToActionWrapperComponent
                                        contentHash={`${this.props.contentHash}-author`}
                                        contextHoverFunction={
                                            context.setHoverComponent
                                        }
                                        contextCloseHover={
                                            context.closeHoverComponent
                                        }
                                        hoverComponent={
                                            <UserLayout
                                                creator={author}
                                                user={user}
                                                requestConnection={
                                                    context.requestConnection
                                                }
                                                updateConnectStatus={
                                                    context.updateAuthorRelationsToUser
                                                }
                                                followUser={context.followUser}
                                                isHighlighted={isHighlighted}
                                            />
                                        }
                                        contextHoveredComponent={
                                            context.hoveredComponent
                                        }
                                        type="author"
                                    >
                                        <div className="main-user-image-container">
                                            <UserImage
                                                isVip={isVip}
                                                image={this.props.author.image}
                                            />
                                        </div>
                                    </HoverCallToActionWrapperComponent>
                                );

                                const hasTopicOrGroup =
                                    !isEmpty(this.props.topic) ||
                                    !isEmpty(this.props.group);

                                return (
                                    <div className="creator-component-content">
                                        {userImage}

                                        <div className="creator-text-content-display">
                                            <div className="creator-information-display">
                                                <div className="creator-username">
                                                    <span className="d-inline-flex align-items-center">
                                                        <span
                                                            className={`author-name-wrapper ${highlightedClass}`.trim()}
                                                        >
                                                            {author.username}
                                                        </span>
                                                        {!(
                                                            author.username ===
                                                                'Anonymous' ||
                                                            author.username ===
                                                                'Fairygodboss'
                                                        ) && (
                                                            <KarmaScoreDisplay
                                                                karmaScore={
                                                                    author.karmaScore
                                                                }
                                                            />
                                                        )}
                                                    </span>
                                                    {this.props.author
                                                        .credential && (
                                                        <span className="creator-credential">
                                                            {author.credential}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="content-information-display">
                                                {this.props
                                                    .formattedTimestamp ? (
                                                    <div className="time-display">
                                                        {
                                                            this.props
                                                                .formattedTimestamp
                                                        }{' '}
                                                        {this.props.edited && (
                                                            <span>
                                                                (Edited)
                                                            </span>
                                                        )}
                                                    </div>
                                                ) : null}
                                                {hasTopicOrGroup ? (
                                                    <div>in</div>
                                                ) : null}
                                                {!isEmpty(this.props.topic)
                                                    ? this.getTopicsComponent(
                                                          context
                                                      )
                                                    : null}
                                                {!isEmpty(this.props.group)
                                                    ? this.getGroupsComponent(
                                                          context
                                                      )
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }}
                        </CommunityContextConsumer>
                    )}
                </PageConsumer>
            </div>
        );
    }
}

CreatorComponent.propTypes = {
    /**
     * Author information
     */
    author: PropTypes.shape(AuthorProps).isRequired,
    /**
     * topic content was posted in
     */
    topic: PropTypes.shape(SingleContentTopicProps),
    /**
     * object of a group
     */
    group: PropTypes.shape(GroupCondensedPropShape),
    /**
     * hash of the content
     */
    contentHash: PropTypes.string,
    edited: PropTypes.bool,
    formattedTimestamp: PropTypes.string,
    /**
     * custom styling to override default
     */
    className: PropTypes.string,
};

CreatorComponent.defaultProps = {
    topic: {},
    group: {},
    contentHash: '',
    edited: false,
    formattedTimestamp: '',
    className: '',
};
